import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "rail-seats-select__wrapper" }
const _hoisted_2 = { class: "rail-seats-select__title-container" }
const _hoisted_3 = { class: "rail-seats-select__title" }
const _hoisted_4 = { class: "rail-seats-select__subtitle" }
const _hoisted_5 = { class: "rail-seats-select-prices" }
const _hoisted_6 = { class: "rail-seats-select-prices__cost rail-seats-select-prices__cost--lower" }
const _hoisted_7 = { class: "rail-seats-select-prices__cost rail-seats-select-prices__cost--total" }
const _hoisted_8 = { class: "rail-seats-select__footer" }
const _hoisted_9 = {
  key: 0,
  class: "p-field-checkbox"
}
const _hoisted_10 = /*#__PURE__*/_createVNode("label", { for: "linen" }, "Постельное бельё включено в стоимость", -1)
const _hoisted_11 = { class: "search-card-footer-controls ml-a" }
const _hoisted_12 = /*#__PURE__*/_createVNode("button", { class: "search-card-footer-controls__dropdown" }, null, -1)

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_coupe_seats = _resolveComponent("coupe-seats")
  const _component_s_v_seats = _resolveComponent("s-v-seats")
  const _component_platscart_seats = _resolveComponent("platscart-seats")
  const _component_seating_seats = _resolveComponent("seating-seats")
  const _component_Checkbox = _resolveComponent("Checkbox")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("h2", _hoisted_3, " Вагон " + _toDisplayString(_ctx.selectedCarriage.cvTrainListReference.number) + " " + _toDisplayString(_ctx.selectedCarriage.categoryCarriagePrinted), 1),
      _createVNode("h3", _hoisted_4, " Класс обсуживания " + _toDisplayString(_ctx.selectedCarriage.classServicesCarriage), 1)
    ]),
    (_ctx.selectedCarriage.categoryCarriagePrinted == 'КУПЕ')
      ? (_openBlock(), _createBlock(_component_coupe_seats, {
          key: 0,
          ck: _ctx.selectedCarriage,
          cv: _ctx.selectedCarriage.cvTrainListReference,
          value: 
        _ctx.selectedCarriage.cvTrainListReference.selected
          ? _ctx.selectedCarriage.cvTrainListReference.selected
              .split(',')
              .map((item) => parseInt(item, 10))
          : []
      ,
          selectSeat: _ctx.selectSeat
        }, null, 8, ["ck", "cv", "value", "selectSeat"]))
      : _createCommentVNode("", true),
    (_ctx.selectedCarriage.categoryCarriagePrinted == 'СВ')
      ? (_openBlock(), _createBlock(_component_s_v_seats, {
          key: 1,
          ck: _ctx.selectedCarriage,
          cv: _ctx.selectedCarriage.cvTrainListReference,
          value: 
        _ctx.selectedCarriage.cvTrainListReference.selected
          ? _ctx.selectedCarriage.cvTrainListReference.selected
              .split(',')
              .map((item) => parseInt(item, 10))
          : []
      ,
          selectSeat: _ctx.selectSeat
        }, null, 8, ["ck", "cv", "value", "selectSeat"]))
      : _createCommentVNode("", true),
    (_ctx.selectedCarriage.categoryCarriagePrinted == 'ПЛАЦ')
      ? (_openBlock(), _createBlock(_component_platscart_seats, {
          key: 2,
          ck: _ctx.selectedCarriage,
          cv: _ctx.selectedCarriage.cvTrainListReference,
          value: 
        _ctx.selectedCarriage.cvTrainListReference.selected
          ? _ctx.selectedCarriage.cvTrainListReference.selected
              .split(',')
              .map((item) => parseInt(item, 10))
          : []
      ,
          selectSeat: _ctx.selectSeat
        }, null, 8, ["ck", "cv", "value", "selectSeat"]))
      : _createCommentVNode("", true),
    (_ctx.selectedCarriage.categoryCarriagePrinted == 'СИД')
      ? (_openBlock(), _createBlock(_component_seating_seats, {
          key: 3,
          ck: _ctx.selectedCarriage,
          cv: _ctx.selectedCarriage.cvTrainListReference,
          value: 
        _ctx.selectedCarriage.cvTrainListReference.selected
          ? _ctx.selectedCarriage.cvTrainListReference.selected
              .split(',')
              .map((item) => parseInt(item, 10))
          : []
      ,
          selectSeat: _ctx.selectSeat
        }, null, 8, ["ck", "cv", "value", "selectSeat"]))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_5, [
      _createVNode("span", _hoisted_6, "Места от " + _toDisplayString(_ctx.selectedCarriage.costTicket) + "₽", 1),
      _createVNode("span", _hoisted_7, "Итого " + _toDisplayString(_ctx.totalCost) + " ₽", 1)
    ]),
    _createVNode("div", _hoisted_8, [
      (_ctx.linen)
        ? (_openBlock(), _createBlock("div", _hoisted_9, [
            _createVNode(_component_Checkbox, {
              id: "linen",
              modelValue: _ctx.linen,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (_ctx.linen = $event)),
              binary: true,
              disabled: _ctx.selectedCarriage.cvTrainListReference.selectLinenBed
            }, null, 8, ["modelValue", "disabled"]),
            _hoisted_10
          ]))
        : _createCommentVNode("", true),
      _createVNode("div", _hoisted_11, [
        _hoisted_12,
        _createVNode("button", {
          class: "search-card-footer-controls__submit",
          onClick: _cache[2] || (_cache[2] = _withModifiers((...args) => (_ctx.save(...args)), ["prevent"]))
        }, " Выбрать ")
      ])
    ])
  ]))
}